import { useEffect } from 'react';

import { postMessageToMobileApp } from 'components/app/helpers';
import { OAuthSuccessFunctionProps } from 'components/Auth/Common/OAuthSignIn/interface';
import OAuthSignInButtons from 'components/Auth/Common/OAuthSignIn/OAuthSignIn';
import { OAUTH_PROVIDERS, POST_MESSAGE_TO_MOBILE_EVENTS } from 'constants/enums';
import { DEFAULT_STATE as OAUTH_DEFAULT_STATE, useOAuthLogin } from 'hooks/useOAuthLogin';
import Box from 'UIKit/Box';

import { DISABLE_2FA_FLOW } from '../Disable2faFaceAuth.constants';
import styles from '../disable2faFaceAuth.module.scss';
import { UpdateWorkflowData } from '../Disable2faFaceAuth.types';
import useVerifyUsingOauth from '../hooks/useVerifyUsingOauth/useVerifyUsingOauth';
import OauthErrorMessage from './OauthErrorMessage';

const VerifyOauth = ({
  updateWorkflowData,
  updateActiveFlow,
}: {
  updateWorkflowData: UpdateWorkflowData;
  updateActiveFlow: (flow: DISABLE_2FA_FLOW) => void;
}) => {
  const { localProvider, requestor, setLocalProvider, error, isLoading, reset } =
    useVerifyUsingOauth({
      updateActiveFlow,
      updateWorkflowData,
    });

  const { setOAuthLoginState } = useOAuthLogin();

  useEffect(() => {
    // clearing oauth data to prevent oauth data being used in login page
    return () => {
      setOAuthLoginState(OAUTH_DEFAULT_STATE);
      // we need to clear  login data stored by google so that google popup comes everytime.
      // else google wont show login popup next time. as user is not logged out at native side.
      postMessageToMobileApp(POST_MESSAGE_TO_MOBILE_EVENTS.OAUTH_LOGOUT, undefined);
    };
  }, [setOAuthLoginState]);

  const handleOAuthSignInSuccess = ({
    accessToken,
    provider,
  }: OAuthSuccessFunctionProps) => {
    setLocalProvider(localProvider);

    requestor({ accessToken, provider });
  };

  const handleOauthButtonClicked = (provider: OAUTH_PROVIDERS) => {
    reset();
    setLocalProvider(provider);
  };

  return (
    <Box className={styles.oauthContainer}>
      <OAuthSignInButtons
        provider={localProvider}
        errorMessage={error && <OauthErrorMessage error={error} />}
        handleOAuthSignInSuccess={handleOAuthSignInSuccess}
        onClickOAuthButton={handleOauthButtonClicked}
        loading={isLoading}
        page="disable2fa"
      />
    </Box>
  );
};

export default VerifyOauth;
